
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NewConnectionComponent } from './newconnection.component';
import { LayoutComponent } from './layout.component';
import { ConnectionNameComponent } from './coonection.name';
import { ConnectionTriggerComponent } from './connection.trigger';
import { ConnectionActionComponent } from './connection.action';
import { AutomationListComponent } from './automation.list';
import { AutomationsummeryComponent } from '../connection/automationsummery/automationsummery.component'
import { SlackUrlRedirectAuthComponent } from "./slack-url-redirect-auth/slack-url-redirect-auth.component";
import { TeamsUrlRedirectAuthComponent } from "./teams-url-redirect-auth/teams-url-redirect-auth.component";

const routes: Routes = [
  {
    path: '', component: LayoutComponent,
    children: [
      { path: '', component: NewConnectionComponent },
      { path: 'automation/:uid', component: AutomationListComponent, pathMatch: 'full' },
      { path: 'summary/:auid', component: AutomationsummeryComponent, pathMatch: 'full' },
      {
        path: 'New/:uid', component: NewConnectionComponent,
        children: [
          { path: '', component: NewConnectionComponent, pathMatch: 'full'},
          { path: '', component: NewConnectionComponent, pathMatch: 'full'},
          { path: 'name', component: ConnectionNameComponent, pathMatch: 'full' },
          { path: 'name/edit/:auid', component: ConnectionNameComponent, pathMatch: 'full' },
          { path: 'trigger/:auid', component: ConnectionTriggerComponent, pathMatch: 'full' },
          { path: 'action/:auid', component: ConnectionActionComponent, pathMatch: 'full' },
          { path: 'summary/:auid', component: AutomationsummeryComponent, pathMatch: 'full' }
        ]
      },
      { path: 'slack-action-auth/:uid/action/:auid', component: SlackUrlRedirectAuthComponent, pathMatch: 'full' },
      { path: 'teams-action-auth/:auid', component: TeamsUrlRedirectAuthComponent, pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConnectionRoutingModule { }
